import { Role } from './Role';

export enum PermissionScope {
    WORKSPACE = 'Workspace',
    RESOURCE = 'Resource',
    NESTED = 'Nested Resource',
}

export enum PermissionAction {
    CREATE = 'create',
    READ = 'read',
    MANAGE = 'manage',
    UPDATE = 'update',
    INVITE = 'invite',
    COMMENT = 'comment',
}

export enum PermissionSubject {
    // Workspace
    ALL = 'all',
    WORKSPACE = 'Workspace',
    USER = 'User',
    MEMBER = 'Member',
    // Workspace Resources
    FOLDER = 'Folder',
    IMPORTED_ENTITY = 'ImportedEntity',
    INVESTMENT = 'Investment',
    MEMO = 'Memo',
    PIPELINE = 'Pipeline',
    DASHBOARD = 'Dashboard',
    LIST = 'List',
    TASK = 'Task',
    TEAM = 'Team',
    // Nested Workspace Resources
    REPORT = 'Report',
    LIST_VIEW = 'ListView',
}

export interface RolePermissionConstraints {
    ownsOnly?: boolean;
    fields?: string[];
    resourceIds?: string[];
    parentResourceIds?: string[];
}

export interface RolePermission {
    id: string;
    role: Role;
    scope: PermissionScope;
    subject: PermissionSubject;
    action: PermissionAction;
    constraints: RolePermissionConstraints | undefined;
}
